import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

export const DRAWER_PINNED_KEY = 'sophia.drawerPinned';

// The drawer is a collapsed icon rail unless the user pinned it open.
const readDrawerMini = (): boolean => {
  try {
    return localStorage.getItem(DRAWER_PINNED_KEY) !== 'true';
  } catch {
    return true;
  }
};

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  logInError: false,
  logInAccountLocked: false,
  inactivityLocked: false,
  userProfile: null,
  planningConfiguration: null,
  dashboardMiniDrawer: readDrawerMini(),
  dashboardShowDrawer: true,
  notifications: [],
  calendars: [],
  physiotherapyUsers: [],
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
